import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';
import { HttpService } from './http.service';
import { SessionService } from './session.service';
import { Login } from '../entities/login.entity';
import { ValidarCodA2P } from '../entities/validarCodA2P.entity';
import { LoginTlf } from '../entities/loginTlf.entity';


@Injectable()
export class UserServiceA2P {

  constructor(private httpService: HttpService, private sessionService: SessionService) { }

  public enviarCodSMS(telefono: string): Observable<any> {
    return this.httpService.httpPost(null, this.sessionService.apiServer + 'SmsA2P/EnviarCodigo?telefono=' + telefono);
  }

  public validarCodSMS(codigo: string): Observable<any> {
    return this.httpService.httpPost(null, this.sessionService.apiServer + 'SmsA2P/ValidarCodigo?codigo=' + codigo);
  }

  public guardarTlf(telefono: string): Observable<any> {
    return this.httpService.httpPost(null, this.sessionService.apiServer + 'SmsA2P/GuardarTelefono?telefono=' + encodeURIComponent(telefono));
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/services/userA2P.service.ts